import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';

export default function Experience() {
    return (
        <div className="experiencesSection" id="experiences">
            <div className="experiencesContainer">
                <div className="innerExperiencesContainer">
                    <div className="experiencesTitling">
                        <p className="experiencesTitle">WORK EXPERIENCE</p>
                    </div>
                    <div className="experiencesGrids">
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Software Developer</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Maintained and optimized full-stack systems using C# and JavaScript, enhancing front-end rendering, page performance, and accessibility while scaling back-end systems for improved customer performance and personalization. Enhanced company CRM portal with C# .NET Razor, integrating features like an in-browser camera app, email marketing management, and customizable inventory display options.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">.NET</p>
                                        <p className="stackTools">C#</p>
                                        <p className="stackTools">JavaScript</p>
                                        <p className="stackTools">HTML/CSS</p>
                                        <p className="stackTools">API Integration</p>
                                        <p className="stackTools">Entity Framework</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Jr. Software Developer</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Developed full-stack solutions with C# and JavaScript, improving back-end search capabilities and performance, while refining front-end design, responsiveness, and feature set across various templates. Upgraded the company CRM portal using C# .NET Razor, delivering new functionalities such as an in-browser camera app, image upload management, enhanced UI/UX design, and analytics tracking for LSO and SEO performance.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">.NET</p>
                                        <p className="stackTools">C#</p>
                                        <p className="stackTools">JavaScript</p>
                                        <p className="stackTools">HTML/CSS</p>
                                        <p className="stackTools">SQL</p>
                                        <p className="stackTools">Entity Framework</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Software Development Intern</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Worked with developers and IT staff to as a computing scholar program intern on the LivIT team. Primarily worked with mentor and Mac services team on a redesign and rebuild of the Mac services website using Django, Bootstrap, and Highcharts.js. Mac services website will be used to observe various management statistics of all Macs in use.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Dango</p>
                                        <p className="stackTools">Python</p>
                                        <p className="stackTools">SQLite3</p>
                                        <p className="stackTools">Jamf MDM API</p>
                                        <p className="stackTools">Highcharts.js</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Webmaster / Web-Developer</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Developed and Rebuilt entire website with HTML, CSS, and JavaScript to accommodate chapter needs. Maintained chapter website while adding additional features to better represent our chapter. Expanded website functionality to properly format for use on multiple devices. Worked with team of students on various large projects during development.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Figma</p>
                                        <p className="stackTools">HTML/CSS</p>
                                        <p className="stackTools">JavaScript</p>
                                    </div>
                                    <div className="innerStackGrid-lower">
                                        <p className="stackTools">"Source Available Above"</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Summer Research Assistant</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Conducted research for the National Science Foundation through Cal State Fullerton's ASSURE-US Program. Attempted to reduce redundancy and load of machine learning on GPUs and accelerate their performance by using YolOX. Aim to train most efficient and accurate model for our overall project so as not to have exuberant computational requirements.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Python</p>
                                        <p className="stackTools">PyTorch</p>
                                        <p className="stackTools">Weights&Biases</p>
                                    </div>
                                    <div className="innerStackGrid-lower">
                                        <p className="stackTools">Roboflow</p>
                                        <p className="stackTools">YolOX</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="experiences">
                            <div className="experienceInner">
                                <p className="experienceIndivTitle">Undergrad Research Assistant</p>
                                <div className="experiencesBar"></div>
                                <p className="experiencesDescriptText">
                                    Funded by Department of Defense to optimize real time image processing for a self-navigating vehicle with a team of undergraduate and graduate students. Experimented with the PyTorch / Anaconda based machine learning system YoLOv5 to train and identify static and moving people and other objects in images and videos compiled by Stanford University. 
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                <div className="innerStackGrid">
                                        <p className="stackTools">Python</p>
                                        <p className="stackTools">PyTorch</p>
                                        <p className="stackTools">Weights&Biases</p>
                                    </div>
                                    <div className="innerStackGrid-lower">
                                        <p className="stackTools">Roboflow</p>
                                        <p className="stackTools">YolOv5</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
